var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCreditCardOff = function SvgCreditCardOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "credit_card_off_svg__a",
    width: 50,
    height: 50,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h50v50H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#credit_card_off_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "m44.402 38.506-2.737-2.737V24.16h-11.61l-6.65-6.65h18.26V13.14q0-.28-.18-.46a.62.62 0 0 0-.46-.181H18.395l-3.125-3.125h25.753q1.579 0 2.673 1.094 1.093 1.094 1.093 2.672V36.86q0 .44-.094.865a2.9 2.9 0 0 1-.294.782m-24.7-14.348H8.332v12.7q0 .241.2.442.2.2.441.2h24.07zM8.973 40.625q-1.578 0-2.672-1.094T5.207 36.86V13.14q0-1.578 1.094-2.672t2.672-1.094h.4L12.5 12.5H8.973a.6.6 0 0 0-.44.2.61.61 0 0 0-.201.441v4.367h4.72L3.732 8.19a1.54 1.54 0 0 1-.474-1.104q-.01-.638.474-1.124.486-.484 1.115-.484.628 0 1.113.484l38.454 38.454q.465.465.474 1.088.01.623-.474 1.107-.486.486-1.114.485-.629 0-1.114-.485l-6.018-5.985z"
  }))));
};
export default SvgCreditCardOff;